import { Link } from 'wouter'

import Feed from './Feed'

interface Props {
  feeds: Record<FeedId, Feed>
  isAdmin: boolean
  onRefresh: () => void
  selectedFeedId: FeedId
  stories: Record<StoryId, Story>
}

export default function FeedList({
  feeds,
  isAdmin,
  onRefresh,
  selectedFeedId,
  stories,
}: Props) {
  const storyList = Object.values(stories)

  const getUnreadCount = (feedId?: FeedId) =>
    storyList.filter(s => !s.is_read && (feedId === undefined || s.feed_id === feedId)).length

  const sortedFeeds = Object.values(feeds).sort((a, b) => a.title.localeCompare(b.title))

  return (
    <ul id="sidebar">
      <Feed
        feedId={0}
        title="All"
        unreadCount={getUnreadCount()}
        isSelected={selectedFeedId === 0}
        alwaysShow
        onRefresh={onRefresh}
      />
      <li className="nav-header">Feeds</li>
      {sortedFeeds.map((feed) => (
        <Feed
          key={feed.feed_id}
          feedId={feed.feed_id}
          title={feed.title}
          unreadCount={getUnreadCount(feed.feed_id)}
          isSelected={selectedFeedId === feed.feed_id}
          alwaysShow={false}
          onRefresh={onRefresh}
        />
      ))}
      <li className="nav-header">Options</li>
      <li><Link href="/add">Add feed</Link></li>
      {isAdmin && <li><Link href="/admin">Admin</Link></li>}
      {/* Intentionally not SPA routing - call GET request */}
      <li><a href="/api/auth/logout">Log out</a></li>
    </ul>
  )
}
